export default __webpack_public_path__ + "images/defaultBanner.accdc757f2c48d61f24c4fbcef2742fd.jpg";